import getPageNameFromPrismicType from '~/lib/get-page-name-from-prismic-type'

import type { LinkProps } from '~/components/UI/Link'

import serializeBreadcrumb from '~/data/serialize-breadcrumb'

export default function serializeCustomBreadcrumb(
  data = null,
  locale,
): LinkProps[] {
  const customBreadCrumb = [...(data?.custom_breadcrumb ?? [])]
  const filteredDocuments = customBreadCrumb?.filter((document) => {
    return document?.document?.id ? document : null
  })

  return filteredDocuments?.length > 0
    ? serializeBreadcrumb({
        items:
          filteredDocuments?.map(({ document }) => {
            return {
              uid: document?.uid,
              type: document?.type,
              name: document?.uid
                ? document.uid
                : getPageNameFromPrismicType(document?.type),
            }
          }) ?? null,
        locale,
      })
    : null
}
